import { Auth } from "amplify-compat"
import React, { useCallback, useEffect, useMemo, useState } from "react"
import { useDispatch } from "react-redux"

import { Router } from "@reach/router"

import { setCurrentUser } from "./auth/actions"
import DashboardPage from "./DashboardPage"
import NotFoundPage from "./NotFoundPage"
import PrivateRoute from "./PrivateRoute"

const App: React.FC<{}> = () => {
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()

  // const logger = useMemo(() => new Logger(App.name), [])

  // ---- SSR-safe logger factory ----
  type LoggerLike = {
    debug: (...a: any[]) => void
    info: (...a: any[]) => void
    warn: (...a: any[]) => void
    error: (...a: any[]) => void
  }

  function createLogger(): LoggerLike {
    if (typeof window !== "undefined") {
      // Only require aws-amplify in the browser (avoids SSR constructor issues)
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const { Logger } = require("amplify-compat")
      return new Logger(App.name)
    }
    // Server: noop/console logger so SSR never crashes
    return {
      debug: () => {},
      info: () => {},
      warn: () => {},
      error: () => {},
    }
  }
  // ---------------------------------

  const logger = createLogger()

  const fetchAuthenticatedUser = useCallback(async () => {
    try {
      const currentUser = await Auth.currentAuthenticatedUser()
      logger.debug("Auth.currentAuthenticatedUser() => ", currentUser)
      dispatch(setCurrentUser(currentUser.attributes))
    } catch (err) {
      logger.error(err)
      dispatch(setCurrentUser(null))
    } finally {
      setLoading(false)
    }
  }, [dispatch, logger])

  useEffect(() => {
    fetchAuthenticatedUser()
  }, [fetchAuthenticatedUser])

  if (loading) return null

  return (
    <Router>
      <PrivateRoute path="app" component={DashboardPage} />
      <NotFoundPage default />
    </Router>
  )
}

export default App
